import toPath from 'lodash/toPath';
import deepEqual from './deepEqual';
import getIn from './getIn';
import setIn from './setIn';
import deleteIn from './deleteIn';

const deleteInWithCleanUp = (state, path) => {
  if (!path) return state;

  if (path[path.length - 1] === ']') {
    const pathTokens = toPath(path);
    pathTokens.pop();
    const parent = getIn(state, pathTokens.join('.'));
    return parent ? setIn(state, path, undefined) : state;
  }
  const result = deleteIn(state, path);
  const dotIndex = path.lastIndexOf('.');
  if (dotIndex > 0) {
    const parentPath = path.substring(0, dotIndex);
    if (parentPath[parentPath.length - 1] !== ']') {
      const parent = getIn(result, parentPath);
      if (deepEqual(parent, {})) {
        return deleteInWithCleanUp(result, parentPath);
      }
    }
  }
  return result;
};

export default deleteInWithCleanUp;
